import { useAuth } from '@clerk/clerk-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';

import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { HeaderContainer } from '~/components/ui/layout/page/HeaderContainer';
import { PageContent } from '~/components/ui/layout/page/PageContent';
import { PageTagline } from '~/components/ui/layout/page/PageTagline';
// Todo: Check if page is needed
export const Route = createFileRoute('/_authLayout/company/list')({
  component: () => <CompanyList />,
});

export const CompanyList = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  if (!auth.isSignedIn && auth.isLoaded) {
    navigate({ to: '/sign-in' });
  }
  return (
    <>
      <HeaderContainer>
        <Breadcrumb
          items={[
            { name: 'Dashboard', url: '/fund/overview' },
            { name: 'Portfolio Companies' },
          ]}
        />
        <PageTagline message="Overview of all portfolio companies across funds" />
      </HeaderContainer>
      <PageContent>
        <div className="pt-3"> TODO Company List</div>
        <div className="pt-3 mb-3">
          <Link to={'/company/mycompany'}> Company List</Link>
        </div>
      </PageContent>
    </>
  );
};
